import { render, staticRenderFns } from "./SelectFacility.vue?vue&type=template&id=0fa95528&"
import script from "./SelectFacility.vue?vue&type=script&lang=ts&"
export * from "./SelectFacility.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports